var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"space-y-6"},[(_vm.$membershipHasPermissionTo('create sms messages'))?_c('NewSmsMessageAction',{attrs:{"contact":_vm.contact},on:{"created":_vm.setLastCreatedAt}}):_vm._e(),_c('MessageList',{key:_vm.lastCreatedAt,attrs:{"contact":_vm.contact}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }